export enum TeamType {
    Undefined = 'Undefined',
    streamAligned = 'Stream-Aligned',
    complicatedSubsystem = 'Complicated-Subsystem',
    platform = 'Platform',
    enabling = 'Enabling'
  }